import { StoreCustomerOrderDetail } from '@/types/http';
import { format } from 'date-fns';

type DeliverySectionProps = {
  dataOrder?: StoreCustomerOrderDetail;
};

export default function DeliverySection({ dataOrder }: DeliverySectionProps) {
  return (
    <div className='mb-3 border-b border-gray-200 pb-3 xl:mb-6 xl:pb-6'>
      <h2 className='mb-4 text-lg font-bold xl:mb-6 xl:text-xl'>Delivery</h2>
      <div className='mb-3 grid w-full gap-6 sm:grid-cols-2 xl:mb-6'>
        <div className='flex flex-col text-sm xl:text-base'>
          <h3 className='font-bold'>Date</h3>
          <span>
            {dataOrder?.created_at ? format(new Date(dataOrder.created_at), 'dd MMMM yyyy') : '-'}
          </span>
        </div>
        <div className='text-sm xl:text-base'>
          <h3 className='font-bold'>Address</h3>
          <span>{dataOrder?.customer?.address || '-'}</span>
        </div>
      </div>
      <div className='grid w-full gap-6 sm:grid-cols-2'>
        <div className='text-sm xl:text-base'>
          <h3 className='font-bold'>Courier</h3>
          <span>{dataOrder?.shipping?.courier_name || '-'}</span>
        </div>
        <div className='text-sm xl:text-base'>
          <h3 className='font-bold'>Payment Method</h3>
          <span className='capitalize'>{dataOrder?.payment_method || '-'}</span>
        </div>
      </div>
    </div>
  );
}
